<template>
  <router-link :to="to"
    class="rb-button-solid"
    :class="{
      'rb-button-solid--touch': isTouchCentric
    }"
  >
    <div class="rb-button-solid__background" />
    <div class="rb-button-solid__content">
      <p class="rb-button-solid__copy">
        <slot></slot>
      </p>
      <span class="rb-button-solid__icon">
        <icon class="rb-button-solid__icon--icon">
          {{buttonIcon}}
        </icon>
      </span>
    </div>
  </router-link>
</template>
<script>
// solid button component
import button from '../mixins/button';

export default {
  name: 'rb-button-solid',
  mixins: [button],
};
</script>

<style lang="scss">
.rb-button-solid {
  @include button-base;
  display: inline-flex;
  text-decoration: none;
  background-color: $color-base-ninja-yellow-base;
  &__copy {
    color: $color-base-ninja-dark-blue-base
  }
  &__background {
    background-color: $color-base-ninja-hover-yellow-base;
    width: 0;
    height: 100%;
    position: absolute;
    border-radius: $size-border-radius-button-base;
    top: 0;
    transition: width 300ms ease;
    width: 0;
    right: 0;
  }
  &__icon {
    display: flex;
    &--icon {
      align-self: center;
      color: $color-base-ninja-dark-blue-base;
    }
  }
  &:hover {
    &:not(.rb-button-solid--touch) {
      .rb-button-solid {
        &__background {
          width: 100%;
          left: 0;
        }
        &__copy {
          color: $color-base-white-base;
        }
        &__icon {
          &--icon {
            color: $color-base-white-base;
          }
        }
      }
    }
  }
}
</style>
